import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 815927F0-0D89-4D10-B336-2B918B321994
 * name arrow-top-right-bottom-left-bold
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-top-right-bottom-left-bold.svg
 * tags
 * - Arrow 
 */
export const ArrowTopRightBottomLeftBoldIcon = createSvgIcon(<><path d="M18.17,8.66L21,11.5V3H12.5L15.34,5.83L5.83,15.34L3,12.5V21H11.5L8.66,18.17L18.17,8.66Z" /></>, 'ArrowTopRightBottomLeftBoldIcon');
export default ArrowTopRightBottomLeftBoldIcon